import { useState } from "react";
import { useNavigate } from "react-router-dom";

import Joi from "joi-browser";
import * as whatsappService from "V2.0/services/whatsappService";

import Form from "V2.0/components/Form";
import CopyInput from "V2.0/common/CopyInput";

import { message } from "antd";

import { showErrorToast } from "V2.0/utils";

import { RiWhatsappFill } from "react-icons/ri";

export function WhatsappForm(props) {
  const { projectId, fetchWhatsappConfiguration, isViewOnly } = props;
  const [loading, setLoading] = useState(false);
  const navigate = useNavigate();

  const [formFieldforWhatsapp] = useState({
    wabaID: "",
    wabaAccessToken: "",
    phoneNumberId: "",
  });

  const [errorMessageWhatsapp] = useState({});

  const templateWhatsapp = [
    {
      name: "wabaID",
      label: "Whatsapp Business Account ID",
      type: "text",
      style: "",
      disabled: isViewOnly
    },
    {
      name: "wabaAccessToken",
      label: "Access token",
      type: "text",
      style: "",
      disabled: isViewOnly
    },
    {
      name: "phoneNumberId",
      label: "Phone Number ID",
      type: "text",
      disabled: isViewOnly
    },
  ];

  const buttonInfoWhatsapp = !isViewOnly ? {
    label: "Connect",
    style: "entire-width",
  } : {};

  const schemaWhatsapp = {
    wabaID: Joi.string()
      .max(25)
      .required()
      .label("WhatsApp Business Account ID"),
    wabaAccessToken: Joi.string().max(300).required().label("Access Token"),
    phoneNumberId: Joi.string().max(50).required().label("Phone Number ID"),
  };

  const handleWhatsapp = async (data) => {
    const updatedObj = {};

    for (let key in data) {
      if (typeof data[key] === "string") {
        updatedObj[key] = data[key].trim();
      } else {
        updatedObj[key] = data[key];
      }
    }

    const { phoneNumberId } = updatedObj;
    const payload = {
      ...updatedObj,
      phoneNumberIds: [phoneNumberId],
    };

    try {
      const response = await whatsappService.manageWhatsapp(projectId, payload);

      if (response.status === 200) {
        message.success("Whatsapp Connected");
        fetchWhatsappConfiguration(projectId);
        setLoading(false);
      }
    } catch (ex) {
      setLoading(false);
      showErrorToast(ex, "Failed to Connect");
    }
  };

  return (
    <div>
      <div className="flex flex-col">
        <div className="w-full max-w-md p-8 border rounded-lg">
          <div className="flex items-center gap-x-2 mb-4">
            <RiWhatsappFill className="size-6 text-green-500" />
            <h3 className="text-md font-medium">Whatsapp Business</h3>
          </div>
          <div>
            <div className="my-5">
              <CopyInput
                type="password"
                value="https://api.apivoicecall.com/api/whatsapp/webhook"
                title="Whatsapp Webhook URL"
              />
            </div>

            <div className="my-5">
              <CopyInput
                type="password"
                value="4915359cede4b64cb190f02bc1b396af"
                title="Verify token"
              />
            </div>
            <div>
              <Form
                key={JSON.stringify(formFieldforWhatsapp)}
                errorMessage={errorMessageWhatsapp}
                inputField={formFieldforWhatsapp}
                template={templateWhatsapp}
                schema={schemaWhatsapp}
                buttonInfo={buttonInfoWhatsapp}
                onSubmit={handleWhatsapp}
                loading={loading}
                setLoading={setLoading}
              />
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}
